module.exports = __webpack_public_path__ + "dfb6ac5ca8c487db2b7c5226d98643e9.svg";